import React from 'react';

import styled from 'styled-components';
import LineLeftQuotedComponent from './LineLeftQuotedComponent';
var moment = require('moment-timezone');
const Balloon = styled.div`
position:relative;
    padding:0px;
    margin-top:15px;
`;
const Faceicon = styled.div`
    float: left;
        margin-right: -50px;
        width: 40px;
`;
const FaceiconImg = styled.img`
    width: 100%;
        height: auto;
        border-radius: 50%;
`;
const DisplayName = styled.div`
    margin:0 0 0 50px;
    font-size:9px;
    font-weight:bold;
    color:#FFF;
text-align:left;
`;
const Chatting = styled.div`
    width: 100%;
        text-align: left;
`;
const Say = styled.div`
    display: inline-block;
        position: relative; 
        margin: 0 0 0 50px;
        padding: 0px;
        max-width: 250px;
        border-radius: 12px;
        background: #edf1ee;
        margin-bottom: 2px;
    &:after{
        content: "";
        display: inline-block;
        position: absolute;
        top: 3px; 
        left: -19px;
        border: 8px solid transparent;
        border-right: 18px solid #edf1ee;
        -ms-transform: rotate(35deg);
        -webkit-transform: rotate(35deg);
        transform: rotate(35deg);
}
`;

const MsgArea = styled.p`
    margin: 0;
        padding: 10px;
word-wrap: break-word;
`;
const Time = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 5px;
    position: absolute;bottom: 0px;
    font-size:10px;
    color:#FFF;
`;


export default class LineImgComponent extends React.Component {
    constructor(props) {
        super(props)
        const dt = new Date(this.props.msg.date)
        this.state = {
            date_time: (dt.getMonth() + 1) + "/" + dt.getDate() + " " + dt.getHours() + ":" + dt.getMinutes(),

        };

    }

    render() {
        return (
            <Balloon className="col-xs-12" >
                <Faceicon><FaceiconImg src={'https://img.global-center.co.jp/v1/line/img/' + this.props.msg.line_user_id + '/200/200'} /></Faceicon>
                <DisplayName>{this.props.msg.display_name}</DisplayName>
                <Chatting>
                    <Say>
                            {this.props.msg.quoted_message_id && this.props.msg.quoted_line ? 

                                <LineLeftQuotedComponent msg={this.props.msg.quoted_line}/>

                            :this.props.msg.quoted_message_id && !this.props.msg.quoted_line ? <div style={{
                                fontSize:"9px", 
                                padding:"10px 10px 3px 10px",
                                borderBottom:"1px solid #dcdcdc",

                            }}>引用先不明</div> 
                            : ""
                            }
                        <MsgArea>
                            <span dangerouslySetInnerHTML={{ __html: this.props.msg.message_text.replace(/\r?\n/g, '<br/>') }} />
                        </MsgArea>
                    </Say>
                    <Time>{moment.utc(this.props.msg.date).format('MM/DD HH:mm')}</Time>
                </Chatting>
            </Balloon>
        );
    }
}
